/**
 * 다운로더
 * @description 일반 브라우저에서 이미지 파일을 anchor tag 로 다운로드 하면 브라우저 탭에서 미리보기가 되는 문제를 우회하기 위한 다운로더
 */
export const useDownloader = async (url: string) => {
  const { name: fileName } = useExtractFileName(url)

  try {
    // 1. fetch file
    const response = await fetch(url)

    // 2. check request success
    if (response.status !== 200) {
      throw new Error(
        `Unable to download file. HTTP status: ${response.status}`
      )
    }

    // 3. get blob data
    const blob = await response.blob()

    // 4. create download link
    const downloadLink = document.createElement('a')
    downloadLink.href = URL.createObjectURL(blob)
    downloadLink.download = fileName

    // 5. trigger a download link
    document.body.appendChild(downloadLink)
    downloadLink.click()

    // 6. clean up
    setTimeout(() => {
      URL.revokeObjectURL(downloadLink.href)
      document.body.removeChild(downloadLink)
    }, 100)
  } catch (err: unknown) {
    if (err instanceof Error) return err
  }
}
